import React from "react";

const Chevron = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 20 20"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M7 5l6 5-6 5"
      fill="none"
      stroke="#878787ff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Chevron;
